import * as HttpService from "../../../../service/HttpService";
import moment from 'moment';

/**
 *查询某树节点属性集
 */
export const getTreeNodeTemplateProps = (ceResSortNo) => {
    return HttpService.get(HttpService.DOMAIN + "/ceResource/getTreeNodeTemplateProps?ceResSortNo=" + ceResSortNo);
};


/**
 *查询某ge节点详细信息
 */
export const getResDetailById = (id, ceResClass) => {
    return HttpService.get(HttpService.DOMAIN + "/eneryResource/getResDetailInfoById?id=" + id + "&ceResClass=" + ceResClass);
};

/**
 * 新增或修改 资源信息
 */
export const resourceCrud = (formValue, modalParams) => {
    var props = {};
    if (modalParams.insertOrModify === 1) {
        formValue.ceCustId = modalParams.nodeId;
        formValue.parentCeResId = modalParams.nodeId;
    } else {
        formValue.id = modalParams.nodeId;
    }
    formValue = JSON.parse((JSON.stringify(formValue) + JSON.stringify(modalParams)).replace(/}{/, ','));
    if (formValue.ceResClass === 2) {
        if (modalParams.ceResSortNo === 'SE_STATION') {
            props = {
                ...props,
                "devNo": formValue.devNo,
                "subsidyScheme": formValue.subsidyScheme,
                "addr": formValue.addr,
                "batteryType": formValue.batteryType,
                "operationDate": formValue.operationDate
            }
        } else {
            props = {
                ...props,
                "floorNumber": formValue.floorNumber,
                "storeyHeight": formValue.storeyHeight,
                "addr": formValue.addr
            }
        }
        formValue.propsMap = props;
        return HttpService.post(HttpService.DOMAIN + "/eneryResource/addOrModifyPart", formValue);
    } else if (formValue.ceResClass === 3) {
        if (modalParams.ceResSortNo === 'BUILDING_ROOM') {
            props = {
                ...props,
                "ceRoomArea": formValue.ceRoomArea,
                "contacter": formValue.contacter,
                "contactPhone": formValue.contactPhone,
                "peopleNumber": formValue.peopleNumber,
            }
        } else if (modalParams.ceResSortNo === 'BUILDING_FLOOR') {
            props = {
                ...props,
                "ceFloorArea": formValue.ceFloorArea,
                "peopleNumber": formValue.peopleNumber,
            }
        } else if (modalParams.ceResSortNo === 'EP_SWITCHING_ROOM') {
            props = {
                ...props,
                "switchingRoomType": formValue.switchingRoomType,
                "operationDate": formValue.operationDate,
            }
        } else if (modalParams.ceResSortNo === 'DIST_CABINET') {
            props = {
                ...props,
                "cabinetsType": formValue.cabinetsType,
                "containerModel": formValue.containerModel,
                "produceDate": moment(formValue.produceDate).format("YYYY-MM-DD"),
                "putTheDate": moment(formValue.putTheDate).format("YYYY-MM-DD"),
            }
        } else if (modalParams.ceResSortNo === 'DIST_SWITCHING_ROOM') {
            props = {
                ...props,
                "switchingRoomType": formValue.switchingRoomType,
                "putTheDate": moment(formValue.putTheDate).format("YYYY-MM-DD"),
            }
        }
        formValue.propsMap = props;
        return HttpService.post(HttpService.DOMAIN + "/eneryResource/addOrModifyCntr", formValue);
    } else {
        // 风电控制器和风电逆变器等信息
        if (modalParams.ceResSortNo === 'DEV_WP_FAN_CONTROLLER' || modalParams.ceResSortNo === 'DEV_WP_FAN_INVERTER') {
            props = {
                ...props,
                "devNo": formValue.devNo,
                "mdrCode": formValue.mdrCode,
                "ratedPower": formValue.ratedPower,
                "installDate":  moment(formValue.installDate).format("YYYY-MM-DD"),
                "operationDate":  moment(formValue.operationDate).format("YYYY-MM-DD"),
            };
        }

        // 用能下的充电自行车充电桩和5G基站等信息
        if (modalParams.ceResSortNo === 'DEV_EBIKE_DEVICE' || modalParams.ceResSortNo === 'DEV_SMART_STREET_LAMP' || modalParams.ceResSortNo === 'DEV_5G_DATA_UNIT') {
            props = {
                ...props,
                "devNo": formValue.devNo,
                "modelCode": formValue.modelCode,
                "mdrCode": formValue.mdrCode,
                "ratedPower": formValue.ratedPower,
                "installDate":  moment(formValue.installDate).format("YYYY-MM-DD"),
                "operationDate":  moment(formValue.operationDate).format("YYYY-MM-DD"),
                "ebike_type":formValue.ebike_type
            };
        }

        //如果等于光伏組件
        if (modalParams.ceResSortNo === 'DEV_PV_MODULE') {
            props = {
                ...props,
                "moduleCount": formValue.moduleCount,
                "moduleType": formValue.moduleType,
                "moduleArea": formValue.moduleArea,
            };
        }
        //如果等于光伏組件
        if (modalParams.ceResSortNo === 'DEV_PV_MODULE') {
            props = {
                ...props,
                "moduleCount": formValue.moduleCount,
                "moduleType": formValue.moduleType,
                "moduleArea": formValue.moduleArea,
            };
        }
        //如果等于光伏->逆变器
        if (modalParams.ceResSortNo === 'DEV_PV_INVERTER') {
            props = {
                ...props,
                "deviceSpec": formValue.deviceSpec,
                "outPutPower": formValue.outPutPower,
                "inverterType": formValue.inverterType,
                "pvNum": formValue.pvNum,
                "pvEload": formValue.pvEload,
                "pvGroupNum": formValue.pvGroupNum,
                "pvGroupCount": formValue.pvGroupCount,
                "pvGroupEload": formValue.pvGroupEload
            };
            
        }
        //如果等于光伏->逆变器PV回路
        if (modalParams.ceResSortNo === 'DEV_PV_INVERTER_PVCIRCUIT') {
            props = {
                ...props,
                "outPutPower": formValue.outPutPower,
            };
        }
        //如果等于光伏->逆变器组串
        if (modalParams.ceResSortNo === 'DEV_PV_INVERTER_GROUPLIST') {
            props = {
                ...props,
                "moduleCount": formValue.moduleCount,
                "outPutPower": formValue.outPutPower,
            };
        }
        //如果等于光伏->汇流箱
        if (modalParams.ceResSortNo === 'DEV_PV_CONFLUENCE_BOX') {
            props = {
                ...props,
                "deviceSpec": formValue.deviceSpec,
                "branchCount": formValue.branchCount,
            };
        }
        //如果等于光伏->计量电表
        if (modalParams.ceResSortNo === 'DEV_PV_METERING_WATT_METER' || modalParams.ceResSortNo === 'DEV_WP_METERING_WATT_METER' ) {
            props = {
                ...props,
                "meter_type": formValue.meter_type,
                "schemeId": formValue.schemeId,
                "schemeName": formValue.schemeName,
            };
        }

        //如果不等于负荷设备
        if (modalParams.ceResSortNo === 'DEV_EP_ELOAD_EQUIP') {
            props = {
                ...props,
                "interruptibleType": formValue.interruptibleType,
                "loadTypes": formValue.loadTypes
            };
            //如果等于间隔
        } else if (modalParams.ceResSortNo === 'DEV_DIST_INTERVAL') {
            props = {
                ...props,
                "intervalType": formValue.intervalType,
                "electricity": formValue.electricity,
                "putTheDate": moment(formValue.putTheDate).format("YYYY-MM-DD"),
            };
            //如果等于清洗机器人 2021-10-15增加
        } else if (modalParams.ceResSortNo === 'DEV_PV_CLEANING_ROBOT') {
            props = {
                ...props,
                "manufacturer": formValue.manufacturer,
                "modelNo": formValue.modelNo,
                "commonAddressNo": formValue.commonAddressNo,
                "manuDate": moment(formValue.manuDate).format("YYYY-MM-DD"),
                "installDate": moment(formValue.installDate).format("YYYY-MM-DD"),
                "installLoc": formValue.installLoc,
                "motorType": formValue.motorType,
                "trackLen": formValue.trackLen,
                "devNo": formValue.devNo,
                "inverter_id": formValue.inverter_id,
                "inverter_name": formValue.inverter_name
            };
            //如果等于PCS（变流器） 2021-11-30tupz 增加
        } else if (modalParams.ceResSortNo === 'DEV_SE_PCS') {
            props = {
                ...props,
                "devNo": formValue.devNo,
                "manufacturer": formValue.manufacturer,
                "type": formValue.type,
                "spec": formValue.spec,
                "capacity": formValue.capacity,
                "epower": formValue.epower
            };
            //如果等于BMS（电池管理系统） 2021-11-30tupz 增加
        } else if (modalParams.ceResSortNo === 'DEV_SE_BMS') {
            props = {
                ...props,
                "devNo": formValue.devNo,
                "manufacturer": formValue.manufacturer,
                "type": formValue.type,
                "spec": formValue.spec,
                "capacity": formValue.capacity
            };
            //如果用汽设备的话，需要优化
        }else if (modalParams.ceResSortNo === 'DEV_DOMESTIC_STEAM_EQUIP' || modalParams.ceResSortNo === 'DEV_PROD_STEAM_EQUIP') {
            props = {
                ...props,
                "manufacturer": formValue.manufacturer,
                "devModel": formValue.devModel,
                "operationDate": formValue.operationDate,
                "proDate": formValue.proDate,
                "accuracyLevel": formValue.accuracyLevel,
                "rangeRatio": formValue.rangeRatio,
                "nominalDiameter": formValue.nominalDiameter,
                "mediumTemp": formValue.mediumTemp,
                "outputSignal": formValue.outputSignal,
                "commInterface": formValue.commInterface,
                "bodyMaterial": formValue.bodyMaterial,
                "defLevel": formValue.defLevel,
                "power": formValue.power
            };
            //如果用气设备的话，
        }else if (modalParams.ceResSortNo === 'DEV_DOMESTIC_GAS_EQUIP'
            || modalParams.ceResSortNo === 'DEV_PROD_GAS_EQUIP' ) {
            props = {
                ...props,
                "manufacturer": formValue.manufacturer,
                "devModel": formValue.devModel,
                "operationDate": formValue.operationDate,
                "proDate": formValue.proDate,
                "sortNo": formValue.sortNo,
                "accuracyRating": formValue.accuracyRating,
                "flowRange": formValue.flowRange,
                "antiExplosionNo": formValue.antiExplosionNo,
                "mediumTemp": formValue.mediumTemp,
                "envTemp": formValue.envTemp
            };
        }else {
            if (formValue.isLoadControl == '1') {
                props = {
                    ...props,
                    "loadType": formValue.loadType
                }
            }
            if (modalParams.ceResSortNo === 'DEV_BUILDING_WATER_PUMP' || modalParams.ceResSortNo === 'DEV_COOLING_WATER_PUMP' || modalParams.ceResSortNo === 'DEV_CHILLED_WATER_PUMP') {
                props = {

                    "headOfDelivery": formValue.headOfDelivery,
                    "isFreConver": formValue.isFreConver,
                    "flux": formValue.flux,
                }
            }
            if (modalParams.ceResSortNo = "DEV_FAN_COIL_TERMINAL") {//空调
                props =
                {
                    ...props,
                    "airConditionerId": formValue.airConditionerId,
                    "airConditionerName": formValue.airConditionerName,
                    "powerType":formValue.powerType
                };
            }
            props =
            {
                ...props,
                "manufacturer": formValue.manufacturer,
                "devModel": formValue.devModel,
                "devForm": formValue.devForm,
                "operationDate": formValue.operationDate,
                "proDate": formValue.proDate,
                "isLoadControl": formValue.isLoadControl,
                "sortNo": formValue.sortNo,
                "accuracyRating": formValue.accuracyRating,
                "flowRange": formValue.flowRange,
                "antiExplosionNo": formValue.antiExplosionNo,
                "mediumTemp": formValue.mediumTemp,
                "envTemp": formValue.envTemp,
                "mdrCode": formValue.mdrCode,
                "modelCode": formValue.modelCode
            };
        }
        formValue.propsMap = props;
        return HttpService.post(HttpService.DOMAIN + "/eneryResource/addOrModifyDevice", formValue);
    }
};

/**
 *查询表计信息
 */
export const getConMeterListInfo = (searchParams, ceCustId, devMeterType) => {
    // let devMeterType = templateClassifyValue==="relationTmplateWater"?"2":"1";
    return HttpService.get(HttpService.DOMAIN + "/ceResource/getConMeterListInfo?meterName=" + searchParams.meterName + "&meterAddr=" + searchParams.meterAddr
        + "&devTermName=" + searchParams.devTermName + "&devTermNo=" + searchParams.devTermNo + "&ceCustId=" + ceCustId + "&flag=" + searchParams.flag + "&devMeterType=" + devMeterType);
};
/**
 *查询空调信息
 */
export const getAirConditionerInfo = (name, current) => {
    return HttpService.get(HttpService.DOMAIN + "/eneryResource/getAirConditionerInfo?ceDeviceName=" + name + "&current=" + current);
};

/**
 *查询用户关联表计信息
 */
export const getMeterInfo = (searchParams) => {
    return HttpService.get(HttpService.DOMAIN + "/ceResource/getMeterInfo?meterName=" + searchParams.meterName + "&meterAddr=" + searchParams.meterAddr);
};

/**
 * 查询用户列表
 */
export const queryUserList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/eneryUser/getUserInfo", params);
};


/**
 * 查询用户分类下拉列表
 */
export const getUserClassify = () => {
    return HttpService.get(HttpService.DOMAIN + "/selectList/getUserClassify");
};


/**
 * 查询运营商下拉列表
 */
export const getOrgList = () => {
    return HttpService.get(HttpService.DOMAIN + "/selectList/getOrgList");
};

/**
 * 查询用户属性集下拉列表
 */
export const getUserSelectProps = () => {
    return HttpService.get(HttpService.DOMAIN + "/selectList/getUserSelectProps");
};

/**
 * 查询用户属性集下拉列表
 */
export const insertOrModifyUser = (resInfo, mapProps) => {
    resInfo = JSON.parse((JSON.stringify(resInfo) + JSON.stringify(mapProps)).replace(/}{/, ','));

    let propsMap = {
        "operationDate": moment(resInfo.operationDate).format("YYYY-MM-DD"),
        "legalPerson": resInfo.legalPerson,
        "bankOfDeposit": resInfo.bankOfDeposit,
        "bankNo": resInfo.bankNo,
        "bankName": resInfo.bankName,
        "locality": resInfo.locality,
        "payType": resInfo.payType,
        "importantEnterprise": resInfo.importantEnterprise,
        "emission_quota": resInfo.emission_quota,
    };
    resInfo.propsMap = propsMap;
    return HttpService.post(HttpService.DOMAIN + "/eneryResource/addOrModifyUser", resInfo);

};

/**
 * 删除资源
 */
export const deleteUserById = (ds) => {
    return HttpService.post(HttpService.DOMAIN + "/ceResource/deleteUserById", ds);
}


/**
 * 拖拽某节点到另一节点中去
 */
export const DragNodeToOtherTreeNode = (ds) => {
    return HttpService.post(HttpService.DOMAIN + "/ceResource/DragNodeToOtherTreeNode", ds);
}



/*查询巡视人员  单位 */
export const queryOrgNo = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/loadRunPlan/queryOrgNo", params);
};

/*查询区域树 */
export const queryDistTreeInfo = (id, ceResClass) => {
    return HttpService.get(HttpService.DOMAIN + "/distResourceTree/getDistTreeInfo?id=" + id + "&ceResClass=" + ceResClass);
};


/*查询区域树最新新增的一条数据 */
export const queryMaxDistTreeInfo = (id, ceResClass) => {
    return HttpService.get(HttpService.DOMAIN + "/distResourceTree/getMaxDistTreeInfo?id=" + id + "&ceResClass=" + ceResClass);
};


/**
 * 新增或修改 区域资源信息
 */
export const distResourceCrud = (formValue, modalParams) => {
    var props = {};
    if (modalParams.insertOrModify === 1) {
        if (modalParams.ceResClass === 2) {
            formValue.distNeighborhoodId = modalParams.nodeId;
            formValue.parentId = modalParams.nodeId;
        } else if (modalParams.ceResClass === 3) {
            formValue.distNeighborhoodId = modalParams.treeNode.distNeighborhoodId;
            formValue.distBuildingId = modalParams.nodeId;
            formValue.parentId = modalParams.nodeId;
        } else if (modalParams.ceResClass === 4) {
            formValue.distNeighborhoodId = modalParams.treeNode.distNeighborhoodId;
            if (formValue.distBuildingUnitId !== 0) {
                formValue.distBuildingUnitId = modalParams.nodeId;
            } else {
                formValue.distBuildingUnitId = 0;
            }
            formValue.distBuildingId = modalParams.treeNode.distBuildingId;

            formValue.parentId = modalParams.nodeId;
        }
    } else {
        formValue.id = modalParams.nodeId;
    }
    formValue.distNeighborhoodResourceType = modalParams.ceResClass;
    if (modalParams.ceResClass === 2) {
        props = {
            ...props,
            "buildUnits": formValue.buildUnits,
            "households": formValue.households,
            "buildArea": formValue.buildArea,
        }
    } else if (modalParams.ceResClass === 3) {
        props = {
            ...props,
            "households": formValue.households,
            "buildArea": formValue.buildArea,
        }
    } else if (modalParams.ceResClass === 4) {
        props = {
            ...props,
            "households": formValue.households,
            "buildArea": formValue.buildArea,
        }
    } else {
        props = {
            ...props,
            "contactPhone": formValue.contactPhone,
            "contacter": formValue.contacter,
            "households": formValue.households,
            "buildArea": formValue.buildArea,
            "buildNum": formValue.buildNum,
        }
    }

    formValue.propsMap = props;
    if (modalParams.insertOrModify === 1) {
        return HttpService.post(HttpService.DOMAIN + "/distResourceTree/addDistResource", formValue);
    } else {
        return HttpService.post(HttpService.DOMAIN + "/distResourceTree/modifyDistNeighborhood", formValue);
    }

};

/**
 *查询区域某ge节点详细信息
 */
export const getDistResourceDetail = (id) => {
    return HttpService.get(HttpService.DOMAIN + "/distResourceTree/getDistResourceDetail?id=" + id);
};

/**
 * 删除区域树节点
 */
export const delDistResouceById = (id) => {
    var ds = { "id": id };
    return HttpService.post(HttpService.DOMAIN + "/distResourceTree/delDistNeighborhood", ds);
};

/**
 * 获取资源上层节点Id list
 */
export const getUpTreeIdList = (id) => {
    return HttpService.get(HttpService.DOMAIN + "/distResourceTree/getUpTreeIdList?id=" + id);
}

/**
 * 根据名称模糊搜索资源树信息
 */
export const getSearchNameList = (name) => {
    return HttpService.get(HttpService.DOMAIN + "/distResourceTree/getSearchNameList?name=" + name);
}

/**
 * 根据名称模糊搜索资源树信息
 */
export const getUpDistById = (disId) => {
    return HttpService.get(HttpService.DOMAIN + "/distResourceTree/getUpDistById?disId=" + disId);
}

/**
 *光伏查询用户下的逆变器列表
 */
export const getInverterLIst = (ceCustId) => {
    return HttpService.get(HttpService.DOMAIN + "/selectList/getInverterList?ceCustId=" + ceCustId);
};
